import React from "react";
import { ArrowRight } from "lucide-react";

const SectionHeader = ({ title, action, onAction, subtitle }) => {
  return (
    <div className="mb-6">
      <div className="flex items-baseline justify-between">
        <h2 className="text-headline font-bold text-gray-900 dark:text-white">
          {title}
        </h2>
        {action && onAction && (
          <button
            onClick={onAction}
            className="flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wide text-accent1 hover:text-accent1/80 dark:text-accent1 dark:hover:text-accent1/80 transition-colors"
          >
            {action}
            <ArrowRight className="h-4 w-4" />
          </button>
        )}
      </div>
      <div className="h-1 w-12 bg-accent1 rounded-sm mt-2" />
      {subtitle && (
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeader;
